/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_3_AInputs */

const en_pc_faq_3_a = /** @type {(inputs: Pc_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft is an open-source studio for controllable AI image and video. PhotoCraft is its image editor and one of the Crafting Apps, alongside VectorCraft, FilmCraft, LightCraft, PdfCraft, EffectCraft and DesignCraft.`)
};

const zh_pc_faq_3_a = /** @type {(inputs: Pc_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 是一个开源工作室，主打可控的 AI 图像和视频。PhotoCraft 是其中的图像编辑器，与 VectorCraft、FilmCraft、LightCraft、PdfCraft、EffectCraft、DesignCraft 同属 Crafting Apps 系列。`)
};

/**
* | output |
* | --- |
* | "ArtCraft is an open-source studio for controllable AI image and video. PhotoCraft is its image editor and one of the Crafting Apps, alongside VectorCraft, Fi..." |
*
* @param {Pc_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_3_a = /** @type {((inputs?: Pc_Faq_3_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_3_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_3_a(inputs)
	return zh_pc_faq_3_a(inputs)
});
export { pc_faq_3_a as "pc.faq.3.a" }